import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/github/workspace/node_modules/@adobe/gatsby-theme-aio/src/components/MDXFilter/index.js";
export const _frontmatter = {};
const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};
const TitleBlock = makeShortcode("TitleBlock");
const TextBlock = makeShortcode("TextBlock");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <TitleBlock slots="heading" theme="lightest" className="titleBlock-align-left" mdxType="TitleBlock" />
    <h2 {...{
      "id": "why-acrobat-services"
    }}>{`Why Acrobat Services?`}</h2>
    <TextBlock slots="image,heading,text" width="33%" theme="lightest" className="align-left img-m-size horizontal-align-heading home-list-points" mdxType="TextBlock" />
    <p><span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "420px"
        }
      }}>{`
      `}<span parentName="span" {...{
          "className": "gatsby-resp-image-background-image",
          "style": {
            "paddingBottom": "95.09433962264151%",
            "position": "relative",
            "bottom": "0",
            "left": "0",
            "display": "block",
            "transition": "opacity 0.5s 0.5s",
            "pointerEvents": "none"
          }
        }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
            "srcSet": ["/document-services/static/f99f1e665002f2db8aabff0b777f7e98/dda86/img-consistent-hifi%402x.webp 265w", "/document-services/static/f99f1e665002f2db8aabff0b777f7e98/8b3fd/img-consistent-hifi%402x.webp 420w"],
            "sizes": "(max-width: 420px) 100vw, 420px",
            "type": "image/webp"
          }}></source>{`
          `}<source parentName="picture" {...{
            "srcSet": ["/document-services/static/f99f1e665002f2db8aabff0b777f7e98/28773/img-consistent-hifi%402x.png 265w", "/document-services/static/f99f1e665002f2db8aabff0b777f7e98/b0db9/img-consistent-hifi%402x.png 420w"],
            "sizes": "(max-width: 420px) 100vw, 420px",
            "type": "image/png"
          }}></source>{`
          `}<img parentName="picture" {...{
            "className": "gatsby-resp-image-image",
            "src": "/document-services/static/f99f1e665002f2db8aabff0b777f7e98/b0db9/img-consistent-hifi%402x.png",
            "alt": "EMPTY_ALT",
            "title": "EMPTY_ALT",
            "loading": "lazy",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "opacity": "0",
              "transition": "opacity 0.5s",
              "color": "inherit",
              "boxShadow": "inset 0px 0px 0px 400px none",
              "top": "0",
              "left": "0"
            }
          }}></img>{`
        `}</picture>{`
    `}</span></p>
    <h3 {...{
      "id": "invent-new-document-experiences"
    }}>{`Invent new document experiences`}</h3>
    <ul>
      <li parentName="ul">
        <p parentName="li">{`Unlock productivity through APIs and integrations.`}</p>
      </li>
      <li parentName="ul">
        <p parentName="li">{`Use Microsoft Power Automate connectors to build without code.`}</p>
      </li>
      <li parentName="ul">
        <p parentName="li">{`Leverage integrations with AEM, Adobe Analytics, and Adobe Acrobat Sign.`}</p>
      </li>
    </ul>
    <TextBlock slots="image,heading,text" width="33%" theme="lightest" className="align-left img-m-size horizontal-align-heading home-list-points" mdxType="TextBlock" />
    <p><span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "358px"
        }
      }}>{`
      `}<span parentName="span" {...{
          "className": "gatsby-resp-image-background-image",
          "style": {
            "paddingBottom": "111.69811320754717%",
            "position": "relative",
            "bottom": "0",
            "left": "0",
            "display": "block",
            "transition": "opacity 0.5s 0.5s",
            "pointerEvents": "none"
          }
        }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
            "srcSet": ["/document-services/static/9f96eb30eb3d18ca77c7c7a514af27d1/dda86/img-customized-experiences%402x.webp 265w", "/document-services/static/9f96eb30eb3d18ca77c7c7a514af27d1/aa963/img-customized-experiences%402x.webp 358w"],
            "sizes": "(max-width: 358px) 100vw, 358px",
            "type": "image/webp"
          }}></source>{`
          `}<source parentName="picture" {...{
            "srcSet": ["/document-services/static/9f96eb30eb3d18ca77c7c7a514af27d1/28773/img-customized-experiences%402x.png 265w", "/document-services/static/9f96eb30eb3d18ca77c7c7a514af27d1/270bd/img-customized-experiences%402x.png 358w"],
            "sizes": "(max-width: 358px) 100vw, 358px",
            "type": "image/png"
          }}></source>{`
          `}<img parentName="picture" {...{
            "className": "gatsby-resp-image-image",
            "src": "/document-services/static/9f96eb30eb3d18ca77c7c7a514af27d1/270bd/img-customized-experiences%402x.png",
            "alt": "EMPTY_ALT",
            "title": "EMPTY_ALT",
            "loading": "lazy",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "opacity": "0",
              "transition": "opacity 0.5s",
              "color": "inherit",
              "boxShadow": "inset 0px 0px 0px 400px none",
              "top": "0",
              "left": "0"
            }
          }}></img>{`
        `}</picture>{`
    `}</span></p>
    <h3 {...{
      "id": "built-for-developers"
    }}>{`Built for developers`}</h3>
    <ul>
      <li parentName="ul">
        <p parentName="li">{`Easy to implement REST APIs and SDKs.`}</p>
      </li>
      <li parentName="ul">
        <p parentName="li">{`Secure, reliable, and scalable.`}</p>
      </li>
      <li parentName="ul">
        <p parentName="li">{`Pay only for what you need.`}</p>
      </li>
    </ul>
    <TextBlock slots="image, heading, text" width="33%" theme="lightest" className="align-left img-m-size horizontal-align-heading home-list-points" mdxType="TextBlock" />
    <p><span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "432px"
        }
      }}>{`
      `}<span parentName="span" {...{
          "className": "gatsby-resp-image-background-image",
          "style": {
            "paddingBottom": "92.45283018867923%",
            "position": "relative",
            "bottom": "0",
            "left": "0",
            "display": "block",
            "transition": "opacity 0.5s 0.5s",
            "pointerEvents": "none"
          }
        }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
            "srcSet": ["/document-services/static/387ffb0c17c9b03cba9b043421ac9a60/dda86/img-workflow-automation%402x.webp 265w", "/document-services/static/387ffb0c17c9b03cba9b043421ac9a60/e3a5e/img-workflow-automation%402x.webp 432w"],
            "sizes": "(max-width: 432px) 100vw, 432px",
            "type": "image/webp"
          }}></source>{`
          `}<source parentName="picture" {...{
            "srcSet": ["/document-services/static/387ffb0c17c9b03cba9b043421ac9a60/28773/img-workflow-automation%402x.png 265w", "/document-services/static/387ffb0c17c9b03cba9b043421ac9a60/dc3b1/img-workflow-automation%402x.png 432w"],
            "sizes": "(max-width: 432px) 100vw, 432px",
            "type": "image/png"
          }}></source>{`
          `}<img parentName="picture" {...{
            "className": "gatsby-resp-image-image",
            "src": "/document-services/static/387ffb0c17c9b03cba9b043421ac9a60/dc3b1/img-workflow-automation%402x.png",
            "alt": "EMPTY_ALT",
            "title": "EMPTY_ALT",
            "loading": "lazy",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "opacity": "0",
              "transition": "opacity 0.5s",
              "color": "inherit",
              "boxShadow": "inset 0px 0px 0px 400px none",
              "top": "0",
              "left": "0"
            }
          }}></img>{`
        `}</picture>{`
    `}</span></p>
    <h3 {...{
      "id": "from-the-leader"
    }}>{`From the leader`}</h3>
    <ul>
      <li parentName="ul">
        <p parentName="li">{`25+ years of PDF expertise.`}</p>
      </li>
      <li parentName="ul">
        <p parentName="li">{`Battle tested by 20M+ users.`}</p>
      </li>
      <li parentName="ul">
        <p parentName="li">{`Innovating with AI/ML in digital documents powered by Adobe Sensei.`}</p>
      </li>
    </ul>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      